import { useRouter } from "@tanstack/react-router";

const isInternal = (url: string) =>
  url.startsWith("/") && !url.startsWith("//");

const isSafeExternal = (url: string) => {
  try {
    const { protocol } = new URL(url);
    return protocol === "https:" || protocol === "http:";
  } catch {
    return false;
  }
};

export const isSafeNotificationUrl = (url: string) =>
  isInternal(url) || isSafeExternal(url);

export function useOpenNotificationUrl() {
  const router = useRouter();
  return (url: string) => {
    if (isInternal(url)) {
      void router.navigate({ href: url });
      return;
    }
    if (!isSafeExternal(url)) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };
}
